import { apiWithToken } from "./api";

// TODO: validar endpoint
const PATH = "/redefinir-senha";

export const putNovaSenha = (payload) => {
  return apiWithToken.put(PATH, payload);
};
